module.exports = __webpack_public_path__ + "static/media/Library_1.294f0245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_1.png
// module id = 1288
// module chunks = 3